// Константы для валидации паролей
export const PASSWORD_MIN_LENGTH = 6;

// Функция для проверки корректности email
export const validateEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email);
};
